<template>
<!-- eslint-disable max-len -->
<div class="background-container" :style="backgroundContainerStyle" ref="bgContainer">
<div class="wrapper" :style="wrapperStyle" ref="wrapper" id="wrapper">
  <div v-if="staticContent" class="background" :style="style"></div>
  <div :class="staticContent ? 'static' : 'background'" :style="staticContent ? {} : style">
    <slot></slot>
  </div>
</div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import isInIframe from '../../../utils/iframe';

export default {
  props: {
    background: { type: String },
    backgroundColor: { type: String },
    slowZoom: { type: Boolean },
    staticContent: { type: Boolean },
    animate: { type: Boolean }
  },
  data() {
    return {
      baseWidth: 1600,
      baseHeight: 900,
      devicePixelRatio: window.devicePixelRatio,
      maximized: false,
      scale: 1
    };
  },
  computed: {
    ...mapGetters([
      'group',
      'myPlayer',
      'avatarSelectBackground',
      'headerHeight',
      'disableForcedLandscape',
      'zoom',
      'zoomStep'
    ]),
    baseAspectRatio() {
      return this.baseWidth / this.baseHeight;
    },
    imgURL() {
      return this.background ? this.resolveAssetPath(this.background, 'backgrounds') : undefined;
    },
    backgroundContainerStyle() {
      const { headerHeight } = this;
      return {
        top: `${headerHeight}px`,
        height: `calc(100% - ${headerHeight}px)`,
        overflow: 'visible'
      };
    },
    wrapperStyle() {
      const zoomMultiplier = this.zoom ? this.zoomStep ** this.zoom : 1;
      const scale = this.scale * zoomMultiplier;
      const scaledWidth = scale * this.baseWidth;
      let { clientWidth, clientHeight } = document.documentElement;
      // make sure to keep the fake landscape condition in-sync with other places it appears in the code
      if (!(this.disableForcedLandscape || isInIframe()) && clientWidth < 767 && clientHeight > clientWidth) {
        clientWidth = window.innerHeight;
        clientHeight = document.documentElement.clientWidth;
      }
      const minXAdjustmentPercent = -(clientWidth / 2) * 100 / scaledWidth;
      const xAdjustmentPercent = Math.max(minXAdjustmentPercent, -50);
      const backgroundColor =
        this.backgroundColor && !this.imgURL ? this.backgroundColor : '';
      const backgroundColorStyle =
        backgroundColor ? { 'background-color': backgroundColor } :
          {};

      document.documentElement.style.setProperty('--gameScaleFrac', scale);
      return {
        transform: `scale(${scale}) translateX(${xAdjustmentPercent}%)`,
        ...backgroundColorStyle,
        width: `${this.baseWidth}px`,
        height: `${this.baseHeight}px`
      };
    },
    style() {
      const backgroundColor =
        this.backgroundColor && !this.imgURL ? this.backgroundColor : '';
      const backgroundImage = this.imgURL ? `url(${this.imgURL})` : '';
      const noBackground = !backgroundColor && !backgroundImage;
      const style = {
        background: noBackground ? 'inherit' : `${backgroundColor} ${backgroundImage}`,
        transform: `scale(${this.slowZoom ? 1.5 : 1})`,
        transition: `${this.animate ? 'background 1s' : ''}${this.slowZoom ? ', transform 20s' : ''}`,
        width: `${this.baseWidth}px`,
        height: `${this.baseHeight}px`
      };
      // console.log(`${style}`);
      // eslint-disable-next-line max-len
      // return `background: ${noBackground ? 'inherit' : `${backgroundColor} ${backgroundImage}`}; transform: scale(${this.slowZoom ? 1.5 : 1}); transition: ${this.animate ? 'background 1s' : ''}${this.slowZoom ? ', transform 20s' : ''}; background-size: ${this.baseWidth}px ${this.baseHeight}px !important; width: ${this.baseWidth}px; height: ${this.baseHeight}px;`;
      return style;
    }
  },
  methods: {
    ...mapMutations([
      'setLastBackground',
    ]),
    ...mapActions([
      'zoomIn',
      'zoomOut'
    ]),
    async handleResize(/* ev */) {
      // alert((ev || {}).type);
      // many many attempts to fix iOS Chrome orientation change zoom bug
      // if (ev && ev.type === 'orientationchange' && (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i))) {
      //   const viewportmeta = document.querySelector('meta[name="viewport"]');
      //   if (viewportmeta) {
      //     viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
      //     document.body.addEventListener('gesturestart', () => {
      //       viewportmeta.content = 'width=device-width, initial-scale=1.0';
      //     }, false);
      //   }
      // }
      if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
        window.scrollBy(-2000, -2000);
        await new Promise(resolve => setTimeout(resolve, 50));
      }
      const devicePixelRatioDelta = window.devicePixelRatio - this.devicePixelRatio;
      const zoom = devicePixelRatioDelta !== 0;
      if (zoom) {
        this.devicePixelRatio = window.devicePixelRatio;

        if (devicePixelRatioDelta > 0) this.zoomIn();
        else this.zoomOut();
      }
      this.setScale();
      const maximized = this.isMaximized();
      // console.log(`maximized: ${maximized} and fullScreen: ${this.isFullScreen()}`);
      const setScaleAgainDelayed = (!maximized && this.maximized !== maximized)
        || (this.$refs.bgContainer
          && (this.$refs.bgContainer.scrollHeight > this.$refs.bgContainer.clientHeight
            || this.$refs.bgContainer.scrollWidth > this.$refs.bgContainer.clientWidth));
      this.maximized = maximized;
      // empirically tested hack, less time or use of Vue.nextTick
      // still leaves small white margins on either side of screen
      // when returning from maximized mode
      if (setScaleAgainDelayed) {
        await new Promise(resolve => setTimeout(resolve, 200));
        this.setScale();
      }
    },
    // checkTilt(e) {
    //   alert('???');
    //   const aig = e.accelerationIncludingGravity;
    //   const x = Math.abs(aig.x);
    //   const y = Math.abs(aig.y);
    //   const z = Math.abs(aig.z);

    //   // If portrait orientation and in one of the danger zones
    //   if ((!window.orientation || window.orientation === 180) && (x > 7 || ((z > 6 && y < 8 || z < 8 && y > 6) && x > 5))) {
    //     alert('!!!');
    //     const viewportmeta = document.querySelector('meta[name="viewport"]');
    //     if (viewportmeta) {
    //       viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
    //       document.body.addEventListener('gesturestart', () => {
    //         viewportmeta.content = 'width=device-width, initial-scale=1.0';
    //       }, false);
    //     }
    //   }
    // },
    async temporarilyKillZoom(ev) {
      const viewportmeta = document.querySelector('meta[name="viewport"]');
      if (viewportmeta) {
        viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
        document.body.addEventListener('gesturestart', () => {
          viewportmeta.content = 'width=device-width, initial-scale=1.0';
        }, false);
      }

      // if (this.$refs && this.$refs.bgContainer) {
      //   alert(`${
      //     window.innerHeight} - ${
      //     this.$refs.bgContainer.clientHeight} = ${
      //     window.innerHeight - this.$refs.bgContainer.clientHeight}`);
      //   if (window.innerHeight - this.$refs.bgContainer.clientHeight > 275) {
      //     await new Promise(resolve => setTimeout(resolve, 250));
      //     this.handleResize();
      //   }
      // }
      if (ev && ev.scale && ev.scale < 0.975) {
        // alert(ev.scale);
        await new Promise(resolve => setTimeout(resolve, 250));
        this.handleResize();
      }
      // else {
      //   alert(window.screen.availHeight);
      //   window.resizeTo(
      //     window.screen.availWidth,
      //     window.screen.availHeight
      //   );
      //   window.scrollBy(-2000, -2000);
      //   window.sizeToContent();
      //   window.resizeBy(2000, 2000);
      // }
    },
    isMaximized() {
      const { width, height } = screen;
      return width === window.outerWidth && height === window.outerHeight;
    },
    isFullScreen() {
      return (window.outerHeight - window.innerHeight) <= 1;
    },
    setScale() {
      // const test = document.documentElement.style.getPropertyValue('--detected-viewport-height');
      // alert(test);
      let { clientWidth, clientHeight } = document.documentElement;
      // make sure to keep the fake landscape condition in-sync with other places it appears in the code
      if (!(this.disableForcedLandscape || isInIframe()) && clientWidth < 767 && clientHeight > clientWidth) {
        clientWidth = window.innerHeight;
        clientHeight = window.innerWidth;
      } else if (clientWidth < 779 && clientHeight < 365 && clientHeight < clientWidth) {
        // clientHeight = (window.screen.availHeight < window.outerHeight) ? window.screen.availHeight : window.innerHeight;
        clientHeight = window.innerHeight;
        // const dvh = document.documentElement.style.getPropertyValue('--detected-viewport-height');
        // clientHeight = (dvh < window.outerHeight) ? dvh : window.innerHeight;
      }
      const height = clientHeight - this.headerHeight;
      const aspectRatio = clientWidth / height;
      const scale =
        aspectRatio > this.baseAspectRatio ? height / this.baseHeight :
          clientWidth / this.baseWidth;
      this.scale = scale;
      this.$store.dispatch('setScale', { scale });
    }
  },
  watch: {
    headerHeight() {
      this.setScale();
    },
    background(newBg, oldBg) {
      // console.log('bg changed');
      // console.log(oldBg);
      // console.log(newBg);
      if (newBg && (newBg !== oldBg)) {
        // console.log('bg setLastBackground');
        this.setLastBackground({ background: newBg });
        // window.lastBackground = newBg;
      }
    },
    group(newGroup, oldGroup) {
      if (newGroup && (newGroup._id !== oldGroup._id) && this.myPlayer && this.myPlayer.lastBackground) {
        console.log('group setLastBackground');
        this.setLastBackground({ background: this.myPlayer.lastBackground });
        // window.lastBackground = this.myPlayer.lastBackground;
      }
    },
    disableForcedLandscape() {
      this.handleResize();
    }
  },
  async mounted() {
    // this.baseHeight -= (this.headerHeight + (window.outerHeight - window.innerHeight));
    window.addEventListener('orientationchange', this.handleResize);
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
      window.addEventListener('gestureend', this.temporarilyKillZoom);
    } else {
      window.addEventListener('resize', this.handleResize);
    }
    // if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
    //   // feature detect
    //   if (typeof DeviceOrientationEvent.requestPermission === 'function') {
    //     DeviceOrientationEvent.requestPermission()
    //       .then((permissionState) => {
    //         if (permissionState === 'granted') {
    //           window.addEventListener('devicemotion', this.checkTilt);
    //         }
    //       })
    //       .catch(console.error);
    //   } else {
    //     // handle regular non iOS 13+ devices
    //     window.addEventListener('devicemotion', this.checkTilt);
    //   }
    // }
    await this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleResize);
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
      window.removeEventListener('gestureend', this.temporarilyKillZoom);
    } else {
      window.removeEventListener('resize', this.handleResize);
    }
    // if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
    //   window.removeEventListener('devicemotion', this.checkTilt);
    // }
  }
};
</script>

<style lang="scss" scoped>
.background-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  overflow: visible;
}
.wrapper {
  background-color: var(--primaryColor);
  position: absolute;
  margin: 0;
  padding: 0;
  transform-origin: top left;
  left: 50%;
  overflow: hidden;
}
.background {
  background-color: var(--primaryColor);
  position: absolute;
  margin: 0;
  padding: 0;
  background-repeat: no-repeat !important;
  background-position: top left !important;
  width: 100%;
  height: 100%;
  background-size: 100% 100% !important;
  transform-origin: center;
  overflow: visible;
}
.static {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: visible;
}
button.background {
  border: none;
}
button.background:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

@media print {
  * {
    overflow: visible !important;
  }
  .wrapper {
    transform: scale(1) translateX(-50%) translateY(5%) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Background.vue